export const APP_DIMENSION_NAME = {
  platform: 'platform',
};

export const VIDEO_DIMENSION_NAME = {
  deviceName: 'm3.dv.n',
};

export const TOOLTIP_FOR_HIDDEN = 'Hide this filter from regular users. Show only to special Conviva users';
